import { noop } from '@/shared/utils/noop';

const OPENED_PREFIX = 'teramot.whatsNew.opened';
const LEGACY_KEY = 'teramot.whatsNewSeen';
const TOASTED_PREFIX = 'teramot.whatsNew.toasted';

function read(key: string): string | null {
  try {
    return localStorage.getItem(key);
  } catch {
    return null;
  }
}

function write(key: string, value: string): void {
  try {
    localStorage.setItem(key, value);
  } catch {
    noop();
  }
}

export function readOpenedVersion(userId: string): string | null {
  try {
    localStorage.removeItem(LEGACY_KEY);
  } catch {
    noop();
  }
  return read(`${OPENED_PREFIX}.${userId}`);
}

export function writeOpenedVersion(userId: string, version: string): void {
  write(`${OPENED_PREFIX}.${userId}`, version);
}

export function readToastedVersion(userId: string): string | null {
  return read(`${TOASTED_PREFIX}.${userId}`);
}

export function writeToastedVersion(userId: string, version: string): void {
  write(`${TOASTED_PREFIX}.${userId}`, version);
}
